
import { Injectable } from '@angular/core';

@Injectable({ providedIn:'root' })
export class GraphqlApiService {
  private endpoint=(typeof window!=='undefined' && (window as any).GRAPHQL_API_ENDPOINT)
    ? (window as any).GRAPHQL_API_ENDPOINT
    : 'http://10.211.55.3:5244/graphql';

  private token:string|null=null;
  private refreshFn:(()=>Promise<string|null>)|null=null;

  setToken(t:string|null){ this.token=t; }
  setTokenRefresh(fn:()=>Promise<string|null>){ this.refreshFn=fn; }

  private headers(){
    const h:any={'Content-Type':'application/json'};
    if(this.token) h['Authorization']=`Bearer ${this.token}`;
    return h;
  }

  async request<T>(query:string, variables?:any):Promise<T>{
    const res = await fetch(this.endpoint,{
      method:'POST',
      headers:this.headers(),
      body:JSON.stringify({query,variables}),
      credentials:'include'
    });

    if(res.status===401 && this.refreshFn){
      const nt = await this.refreshFn();
      if(nt){
        this.token=nt;
        return await this.request<T>(query,variables);
      }
    }

    const json=await res.json();
    if(json.errors){
      throw new Error(json.errors.map((e:any)=>e.message).join(','));
    }

    return json.data as T;
  }
}
